(()=>{'use strict';
const form=document.querySelector('[data-rfq-contact]');if(!form)return;
let pending=false,lastSent='';
form.addEventListener('submit',async event=>{
event.preventDefault();if(pending||!form.reportValidity())return;
const status=form.querySelector('[data-rfq-status]'),button=form.querySelector('button[type="submit"]');
const show=(key,error=false)=>{status.hidden=false;status.textContent=form.dataset[key];status.classList.toggle('form-error',error);status.classList.toggle('form-success',!error);};
const data={};for(const [key,value] of new FormData(form)){if(key==='email'||key.startsWith('_'))data[key]=value;else if(key.startsWith('contact['))data[key.slice(8,-1)]=value;}
data._subject='MoTai wholesale enquiry · '+(data.reference||'RFQ');
data._url=location.origin+location.pathname+location.search;
const body=JSON.stringify(data);
if(body===lastSent){show('statusSuccess');status.scrollIntoView({block:'center',behavior:'smooth'});return;}
pending=true;button.disabled=true;form.setAttribute('aria-busy','true');show('statusSending');
const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),25000);
try{const response=await fetch(form.dataset.rfqEndpoint,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body,signal:controller.signal});
const result=await response.json();
if(/activat|confirm.*email|check.*email/i.test(String(result.message||''))){show('statusActivation',true);}
else if(!response.ok||!(result.success===true||result.success==='true')){throw new Error('Submission not confirmed');}
else{lastSent=body;show('statusSuccess');}
}catch{show('statusError',true);}finally{clearTimeout(timer);pending=false;button.disabled=false;form.removeAttribute('aria-busy');status.scrollIntoView({block:'center',behavior:'smooth'});}
});
})();
